import { useIntl } from 'react-intl';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { api } from '../../../../../modules/api/api';
import { useAuth } from '../../../../../modules/auth';
import { useToast } from '../../../../../modules/components/toast/ToastContext';
import { SiService } from '../../../mappings';

export const useListCategorizeAndBrandImages = (
  enabled = true,
  requestIdFilter?: string | string[],
  isPublic = false
) => {
  const { currentUser, auth, refresh } = useAuth();
  const params = useParams();
  const intl = useIntl();
  const { setToast } = useToast();

  const resolvedRequestIdFilter = requestIdFilter ?? params?.id;

  return useQuery(
    ['site-intelligence-categorize-brand-images', params, resolvedRequestIdFilter],
    async () => {
      if (isPublic) {
        try {
          const endpoint = new URL(
            `public/v1/list_capture`,
            process.env.REACT_APP_SITE_INTELLIGENCE_BACKEND_SERVICE_BASE_URL
          ).href;

          const { result, status } = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'X-Service-Client': 'cbp',
              'content-type': 'application/json',
            },
            body: JSON.stringify({
              filters: {
                request_id: resolvedRequestIdFilter,
                service: [SiService.BRAND_DETECT_SERVICE, SiService.CATEGORIZE_SERVICE],
                status: ["ACTIVE"],
              },
              sort_order: {
                name: 'service',
                sort: -1,
              },
              offset: 0,
              limit: 99999,
            }),
          }).then(async (resp) => {
            const result = await resp?.json();
            return { result: result, status: result?.code ?? resp?.status };
          });
          const resolvedResult = await result;
          if (status === 200 && resolvedResult.code === 200 && resolvedResult.error === false)
            return result;
        } catch (err) {
          const response = await err?.response?.json();
          setToast({
            show: true,
            type: 'Danger',
            header: intl.formatMessage({ id: 'MESSAGE.ERROR' }),
            message: response?.message ?? err.message,
          });
        }
      } else {
        try {
          const { result, status } = await api(
            `admin/v1/list_capture`,
            {
              method: 'POST',
              headers: {
                'content-type': 'application/json',
              },
              body: JSON.stringify({
                filters: {
                  request_id: resolvedRequestIdFilter,
                  service: [SiService.BRAND_DETECT_SERVICE, SiService.CATEGORIZE_SERVICE],
                  status: ["ACTIVE"],
                },
                sort_order: {
                  name: 'service',
                  sort: -1,
                },
                offset: 0,
                limit: 99999,
              }),
            },
            { token: auth?.accessToken, refresh },
            'site-intelligence'
          ).then(async (resp) => {
            const result = await resp?.json();
            return { result: result, status: result?.code ?? resp?.status };
          });
          const resolvedResult = await result;
          if (status === 200 && resolvedResult.code === 200 && resolvedResult.error === false)
            return result;
        } catch (err) {
          const response = await err?.response?.json();
          setToast({
            show: true,
            type: 'Danger',
            header: intl.formatMessage({ id: 'MESSAGE.ERROR' }),
            message: response?.message ?? err.message,
          });
        }
      }
    },
    { enabled: enabled }
  );
};
